import React from 'react'
import { Outlet } from 'react-router'
import Header from '../header/header'
import SideBar from '../sidebar/sideBar'

interface Props { }

function DashboardLayout(props: Props) {
    const { } = props

    return (
        <div className="flex flex-col h-screen overflow-hidden">
            {/* Header - fixed at top */}
            <Header />

            {/* Body - sidebar + main content fill remaining height */}
            <div className="flex flex-1 overflow-hidden bg-[#F7F7FB]">
                {/* Sidebar - scrolls independently */}
                <SideBar />

                {/* Main content - scrolls independently */}
                <main className="flex-1 min-w-0 overflow-y-auto overflow-x-hidden">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}

export default DashboardLayout
